import { Component, OnDestroy, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Router } from "@angular/router";

import { BaseHelper } from "./baseHelper";
import { Pages } from "./interfaces/pages";
import { GlobalProvider } from "src/services/global";
import { UserAPIService } from "src/services/user_api.service";
import { AuthService } from "src/services/auth.service";
import { MenuHelper } from "./menuHelper";
import { PublicAPI } from "src/services/public_api.service";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { currentVersion } from "src/environments/environment";
import { AlertController } from "@ionic/angular";
import { FcmService } from "src/services/fcm.service";
import { BarcodeScanner } from "@capacitor-community/barcode-scanner";
import { NotificationServiceApi } from "src/services/notification.service";
import { LocationService } from "src/services/location.service";
import { fromEvent, merge, of, Subscription } from "rxjs";
import { map } from "rxjs/operators";

import { AfterViewInit, ViewChild } from '@angular/core';
import { LoaderComponent } from './components/loader/loader.component';
import { LoaderService } from './components/loader/loader.service';
import { BackgroundService } from 'backgroundservice';
import { IonRouterOutlet } from '@ionic/angular';




@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: [
    "app.component.scss",
    "./style/side-menu.scss",
    "./style/side-menu.responsive.scss",
  ],
  standalone: false
})
export class AppComponent
  implements OnInit, OnDestroy {

  textDir;
  latitude: number | null = null;
  longitude: number | null = null;
  ////try
  networkStatus: boolean = false;
  networkStatus$: Subscription = Subscription.EMPTY;
  private resumeListener: any = null;

  private locationSub: any;
  lastBackPress = 0;


  @ViewChild(IonRouterOutlet, { static: true }) routerOutlet: IonRouterOutlet;


  // public generalPages: Array<Pages>;
  constructor(
    private platform: Platform,
    public b: BaseHelper,
    private userAPI: UserAPIService,
    private authAPI: AuthService,
    private pubApi: PublicAPI,
    public g: GlobalProvider,
    public m: MenuHelper,
    private router: Router,
    private alertCtrl: AlertController,
    private fcm: FcmService,
    private loaderService: LoaderService,
    private notificationServiceApi: NotificationServiceApi,
    private locationService: LocationService,
  ) {
    this.initializeApp();

  }



  ///// try
  ngOnInit(): void {

    // this.locationSub = this.locationService.watchPosition((pos) => {
    //   this.g.latitude = pos.latitude;
    //   this.g.longitude = pos.longitude;

    //   console.log(' Global GPS:', this.g.latitude, this.g.longitude);
    // });
    // this.checkNetworkStatus();
    this.setupAppResumeListener();
  }

  ngOnDestroy(): void {
    //this.locationService.stopWatching(this.locationSub);
    this.networkStatus$.unsubscribe();
    if (this.resumeListener) {
      this.resumeListener.remove();
    }
  }

  /** Run when app comes back from background (removed from background). */
  private async setupAppResumeListener() {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    // this.resumeListener = await App.addListener("resume", () => {
    //   this.locationNotification();
    // });
    // this.resumeListener = await App.addListener("pause", () => {
    //   this.locationNotification();
    // });
  }

  checkNetworkStatus() {
    this.networkStatus = navigator.onLine;
    this.networkStatus$ = merge(
      of(null),
      fromEvent(window, "online"),
      fromEvent(window, "offline")
    )
      .pipe(map(() => navigator.onLine))
      .subscribe(async (status) => {
        // console.log("internet connection status", status);
        // this.b.toast(`Internet connection status: ${status}`, 10000, "warning");
        this.networkStatus = status;

        if (!this.networkStatus) {
          this.b.toast(
            `Internet connection not found. Please ensure that you are connected to an internet, and try again.`,
            20000,
            "danger"
          );
        } else {
          // this.b.toast(`Internet connection found.`, 20000, "success");
        }

        const tokenObj = await this.b.getJws();
        if (tokenObj) {
          this.g.token = tokenObj;
        } else {
          this.g.token = null;
        }
        if (this.g.token) {
          // this.b.toast(
          //   `G-Token found on internet connection ${this.networkStatus}.`,
          //   20000,
          //   "success"
          // );
          // this.g.token = tokenObj;
          this.g.gHasToken = true;
        } else {
          // this.b.toast(
          //   `G-Token not found on internet connection ${this.networkStatus}.`,
          //   20000,
          //   "danger"
          // );
        }
      });
  }
  ///// end of try

  initializeApp() {
    // this.locationNotification();
    this.platform.ready().then(async () => {

      this.platform.backButton.subscribeWithPriority(10, () => {

        if (this.router.url === '/main/home') {

          const now = Date.now();

          if (now - this.lastBackPress < 2000) {
            App.exitApp();
          } else {
            this.b.toast("Press back again to exit", 2000, "warning");
            this.lastBackPress = now;
          }

        } else if (this.routerOutlet && this.routerOutlet.canGoBack()) {

          this.routerOutlet.pop();

        } else {

          this.router.navigateByUrl('/main/home');

        }

      });
      this.checkNetworkStatus();
      this.b.menuOpen();
      this.checkVersion();

      const urlParams = new URLSearchParams(window.location.search);
      const sso = urlParams.get("sso");
      const resetToken = urlParams.get("resetToken");
      if (resetToken) {
      } else {
        if (sso) {
        } else {
          const tokenObj = await this.b.getJws();
          console.log("tokenObj?", tokenObj)
          // console.log(`this.router.url?`, this.router.url);

          // const publicGi = await (await this.pubApi.globalSetting()).toPromise().catch((err) => {
          //   return Promise.resolve(null);
          // });
          // if (publicGi) {
          //   const { detail } = publicGi;
          //   console.log(publicGi);
          //   this.g.loadGlobalSetting(detail);
          // }


          if (tokenObj) {
            // console.log(`have token tokenObj?`, tokenObj);
            const { profileType } = tokenObj;
            const result = await (
              await this.authAPI.loginViaToken('Bearer ' + tokenObj)
            )
              .toPromise()
              .catch((err) => {
                return Promise.resolve(null);
              });
            console.log('resulttokenObj', result);
            //   if(result){
            //     let rewards = await (
            //   await this.authAPI.loginRewards('Bearer ' + tokenObj)
            // )
            //   .toPromise()
            //   .catch((err) => {
            //     return Promise.resolve(null);
            //   });
            //   if (rewards?.ok) {
            //     localStorage.setItem("dailyReward", "true");
            //   }

            //   }
            // console.log(`loginviatoken?`, result);
            // check if result is null || token expired
            if (!result) {
              // when token is null
              this.g.gHasToken = true;
              this.g.loadingJwt = false;
              // this.b.clearJws();
              return this.b.navigateRoot("/login");
            }
            const r: any = result;
            try {
              await this.b.setJws(tokenObj, r.profile, r.mediaUrl);
              // await this.fcm.initPush();
              await this.b.loadLoading(false);

              await this.checkDailyReward(tokenObj);

              this.b.menuOpen();
              this.b.menuOpen();
              console.log("this.g.profile", this.g.profile)
              await BackgroundService.echo({ value: this.g.profile?.id.toString() });
              await BackgroundService.start();
              // console.log("check cartLoaded?", this.g.cartLoaded);
              // console.log(`this.router.url (2)`, this.router.url);
              //
            } catch (error) {
              console.error('Error during app initialization after login:', error);
            } finally {
              this.g.loadingJwt = false;
            }
            // if (`/login` === this.router.url) {
            //   console.log(`enter login`);
            //   this.g.loadingJwt = false;
            //   this.b.navigateRoot(`/customer`);
            //   return;
            // } else if (`/login/admin` === this.router.url) {
            //   this.g.loadingJwt = false;
            //   this.b.navigateRoot(`/customer`);
            //   return;
            // }

            if (!this.g.accessCode) {
              // this.gacH.generateAccessCode();
              this.b.loadLoading(false);
            } else {
              this.g.accessCode = this.g.profile.accessCode;
            }
          } else {
            // this.b.toast(
            //   `Oops! Looks like you've been logged out. Please log in again.`,
            //   3000,
            //   "tertiary"
            // );
            this.g.loadingJwt = false;
            this.b.clearJws();
            this.b.navigateRoot(`/login`);
          }
        }
      }
    });
  }


  private async checkDailyReward(tokenObj: any) {
    try {
      const rewards = await (
        await this.authAPI.loginRewards('Bearer ' + tokenObj)
      )
        .toPromise()
        .catch(() => null);

      if (rewards?.ok) {
        localStorage.setItem("dailyReward", "true");
      }

    } catch (e) {
      console.log("Daily reward check failed", e);
    }
  }


  async generateSSO() {
    (await this.userAPI.generateSSO()).subscribe((result) => {
      const r: any = result;

      if (!r.ok) return;
      this.b.toast(r.detail.ssoToken, 10000);
    });
  }
  async showBearer() {
    this.b.toast(this.g.jws, 10000);
  }

  goToWebsite() {
    this.b.openTab(`https://qzonetech.com`);
  }
  logout() {
    // this.ns.disconnect();
    this.b.toast(`Successfully logged out.`);
    this.b.clearJws();
    this.b.navigateRoot(`/login`);
  }
  profile() {
    this.b.navigateRoot(`/profile`);
  }
  stopCamera() {
    BarcodeScanner.stopScan();
    document.querySelector("#splitPane").classList.remove("scanner-active");
    document.querySelector("#cameraScreen").classList.remove("showDisplay");
    document.querySelector("#cameraScreen").classList.add("hideDisplay");
  }
  async checkVersion() {
    const result2 = await (await this.pubApi.globalSetting())
      .toPromise()
      .catch((err) => {
        return Promise.resolve(null);
      });
    console.log('result2', result2);
    if (result2) {
      this.g.globalSetting = result2.detail;
      this.g.androidVersion = result2.detail.androidVersion;
      this.g.iosVersion = result2.detail.iosVersion;
      // const r2: any = result2;
      // console.log(`globalSetting?`, r2);
      // this.g.posSetting.taxName = r2.detail.taxName;
      // this.g.posSetting.taxRate = r2.detail.taxRate;
      // this.g.posSetting.taxRateInString = `${(
      //   r2.detail.taxRate * 100
      // ).toFixed()}`;
      // this.g.mediaUrl = r2.mediaUrl;
      // // this.g.appLandingSite = r2.detail.appLandingSite;
      // this.g.iosVersion = r2.detail.iosVersion;
      // this.g.androidVersion = r2.detail.androidVersion;
      // this.g.appAnnouncement = r2.detail.appAnnouncement;
      // this.g.toggleAppAnnouncement = r2.detail.toggleAppAnnouncement;
      // this.g.affiliateGroupCodeMessage = r2.detail.affiliateGroupCodeMessage;
      // this.g.affiliateTopupLimit = Number(r2.detail.affiliateTopupLimit);
      // this.g.affiliateGroupRemovalCountdown =
      //   r2.detail.affiliateGroupRemovalCountdown;
      // this.g.topupDisclaimerMessage = r2.detail.topupDisclaimerMessage;
      // this.g.termsAndConditions = r2.detail.termsAndConditions;
      // this.g.pdpa = r2.detail.pdpa;

      if (Capacitor.getPlatform() === "ios") {
        if (this.g.iosVersion !== currentVersion) {
          const alertIOS = await this.alertCtrl.create({
            // cssClass: "",
            header: "A new version is available",
            message: "Do you want to update to the latest version?",
            buttons: [
              {
                text: "Cancel",
                role: "cancel",
                cssClass: "secondary",
                handler: (blah) => {
                  // console.log("Confirm Cancel: blah");
                },
              },
              {
                text: "Update",
                handler: async () => {
                  this.b.openExternalLink(
                    `https://apps.apple.com/us/app/snatchit-app/id6443795989`
                  );
                },
              },
            ],
          });
          await alertIOS.present();
        }
      }
      if (Capacitor.getPlatform() === "android") {
        console.log(`currentVersion?`, currentVersion);
        console.log(`this.g.androidVersion?`, this.g.androidVersion);
        if (this.g.androidVersion !== currentVersion) {
          const alertIOS = await this.alertCtrl.create({
            // cssClass: "",
            header: "A new version is available",
            message: "Do you want to update to the latest version?",
            buttons: [
              {
                text: "Cancel",
                role: "cancel",
                cssClass: "secondary",
                handler: (blah) => {
                  // console.log("Confirm Cancel: blah");
                },
              },
              {
                text: "Update",
                handler: async () => {
                  this.b.openExternalLink(
                    `https://play.google.com/store/apps/details?id=io.qzt.snatchit`
                  );
                },
              },
            ],
          });
          await alertIOS.present();
        }
      }
    } else {
    }
  }
  async locationNotification() {
    const pos = await this.locationService.getCurrentLocation();
    console.log('posData', pos);

    // use current location coordinates
    this.latitude = pos.latitude;
    this.longitude = pos.longitude;

    const data = {
      lat: this.latitude,
      lng: this.longitude,

    };
    console.log('locationNotification response', data);

    const response: any = await (
      await this.notificationServiceApi.locationNotification(data)
    )
      .toPromise()
      .catch((err) => {
        console.error('locationNotification error', err);
        return null;
      });

    console.log('locationNotification response', response);
  }
}
